/* src/app/shared/dialogs/ag-confirm-dialog/ag-confirm-dialog.component.scss */
.dialog-main-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 532px;
  max-width: calc(100vw - 48px);
}
.dialog-information-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.dialog-title {
  font-family: "Poppins-Regular";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  color: #222222;
}
.dialog-description {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
  overflow-wrap: break-word;
}
.buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}
.dialog-title-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  position: relative;
}
.dialog-cross-icon-box {
  width: 20px;
  height: 20px;
  padding: 2px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dialog-cross-icon {
  display: block;
}
::ng-deep .ag-confirm-dialog-panel .mat-mdc-dialog-container {
  border-radius: 16px !important;
  --mdc-dialog-container-shape: 16px;
  background-color: #ffffff;
}
::ng-deep .ag-confirm-dialog-panel .mdc-dialog__surface {
  border-radius: 16px !important;
  box-shadow: none !important;
}
::ng-deep .cdk-global-overlay-wrapper:has(.file-size-warning-dialog) {
  z-index: 2000;
}
::ng-deep .file-size-warning-backdrop {
  z-index: 1999;
}
/*# sourceMappingURL=ag-confirm-dialog.component.css.map */
